var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-time",
    transform: "translate(-155 -1141)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 38,
    cy: 38,
    r: 38,
    transform: "translate(155 1141)",
    fill: "#7c8b29",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-calendar-4755488",
    transform: "translate(89.277 1125.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M96.883,33.326h2.986V27.22a1.146,1.146,0,1,1,2.292,0v6.106h14.751V27.22a1.146,1.146,0,1,1,2.292,0v6.106h14.751V27.22a1.146,1.146,0,0,1,2.292,0v6.106h2.986a6.508,6.508,0,0,1,6.49,6.49V73.694a6.508,6.508,0,0,1-6.49,6.49H96.886a6.508,6.508,0,0,1-6.49-6.49V39.816a6.508,6.508,0,0,1,6.49-6.49Zm18.6,39.192a1.146,1.146,0,0,1,0-2.292h5.155a1.146,1.146,0,1,1,0,2.292Zm-13.432,0a1.146,1.146,0,0,1,0-2.292H107.2a1.146,1.146,0,0,1,0,2.292Zm26.866-9.789a1.146,1.146,0,0,1,0-2.292h5.155a1.146,1.146,0,1,1,0,2.292Zm-13.432,0a1.146,1.146,0,1,1,0-2.292h5.155a1.146,1.146,0,1,1,0,2.292Zm-13.432,0a1.146,1.146,0,1,1,0-2.292H107.2a1.146,1.146,0,1,1,0,2.292Zm26.866-9.788a1.146,1.146,0,0,1,0-2.292h5.155a1.146,1.146,0,1,1,0,2.292Zm-13.432,0a1.146,1.146,0,1,1,0-2.292h5.155a1.146,1.146,0,1,1,0,2.292Zm-22.8-11.564h50.747V39.814a4.214,4.214,0,0,0-4.2-4.2H96.887a4.214,4.214,0,0,0-4.2,4.2v1.563Zm50.747,2.291H92.686V73.692a4.214,4.214,0,0,0,4.2,4.2h42.346a4.214,4.214,0,0,0,4.2-4.2V43.668Z",
    transform: "translate(0 0)",
    fill: "#2b400f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.082aacc1d4ab2efe19eb70ed2cdd8744.svg";
export { ForwardRef as ReactComponent };